import { useQuery } from '@tanstack/react-query';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { QUERY_KEYS } from './consts';

export const useBitbucketConfigQuery = () =>
  useQuery({
    queryKey: [QUERY_KEYS.BITBUCKET_CONFIG],
    queryFn: () => RepositoryClient.bitbucketGetConfig(),
  });
